var DurationUtil = /** @class */ (function () {
    function DurationUtil() {
    }
    DurationUtil.convertDurationToString = function (duration) {
        // refactor to use translations
        var sign = duration.isNegative ? "-" : "";
        var isElapsed = duration.isElapsed ? "e" : "";
        var weeksString = "w";
        var daysString = "d";
        var hoursString = "h";
        var minutesString = "m";
        var secondsString = "s";
        var millisString = "ms";
        var weeks = duration.weeks ? "" + duration.weeks + weeksString + " " : "";
        var days = duration.days ? "" + duration.days + daysString + " " : "";
        var hours = duration.hours ? "" + duration.hours + hoursString + " " : "";
        var minutes = duration.minutes ? "" + duration.minutes + minutesString + " " : "";
        var seconds = duration.seconds ? "" + duration.seconds + secondsString + " " : "";
        var millis = duration.milliseconds ? "" + duration.milliseconds + millisString : "";
        var durationString = ("" + sign + isElapsed + weeks + days + hours + minutes + seconds + millis).trim();
        // milestones have an empty duration object, so nothing will populate the durationString
        // legacy milestones are returned as elapsed with no time component
        if (durationString == "") {
            durationString = "0";
        }
        else if (durationString == "e") {
            durationString = "~0";
        }
        return durationString;
    };
    return DurationUtil;
}());
export { DurationUtil };
//# sourceMappingURL=DurationUtil.js.map